import { menu as menuWidget } from "instantsearch.js/es/widgets"
// https://www.algolia.com/doc/api-reference/widgets/menu/js/
export const siteMenu = menuWidget({
  container: '#refinementList',
  attribute: 'type',
  sortBy: ['count:desc', 'name:asc'],
  cssClasses: {
    root: 'w-48 pr-6 lg:pr-10',
    list: [
    ],
    label: [
      'text-blue',
      'underline',
      'font-bold'
    ],
    selectedItem: [
      'text-black'
    ],
    link: [
      'flex items-center gap-4'
    ],
    count: [
      'ml-auto text-sm text-gray-500'
    ]
  },
})
